Ext.define('PanelWizardFilterTypyOperacji', {
    extend: 'Ext.panel.Panel',
    initComponent: function () {
        this.cid = Ext.id();
        Ext.apply(this, {
            layout: "fit",
            frame: false,
            border: false,
            autoWidth: false,
            autoHeight: false,
            items: [{
                xtype: 'form',
                frame: false,
                border: false,
                autoWidth: true,
                autoHeight: true,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0"
                },
                id: this.cid + "formpanel",
                labelWidth: 100,
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1.0,
                        layout: 'form',
                        labelWidth: 100,
                        defaults: {
                            anchor: "0"
                        },
                        frame: false,
                        border: false,
                        items: [{
                            id: this.cid + "DOLEWKA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[0].capitalise()
                        }, {
                            id: this.cid + "NAPRAWA_BIEZACA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[1].capitalise()
                        }, {
                            id: this.cid + "OBSLUGA_TECHNICZNA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[2].capitalise()
                        }, {
                            id: this.cid + "NAPRAWA_GWARANCYJNA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[3].capitalise()
                        }, {
                            id: this.cid + "NAPRAWA_WYPADKOWA",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[4].capitalise()
                        }, {
                            id: this.cid + "OPIS_NIE_DOTYCZY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[5].capitalise()
                        }, {
                            id: this.cid + "POGOTOWIE_TECHNICZNE",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_operacji[6].capitalise()
                        }]
                    }]
                }]
            }]
        });
        this.callParent(arguments);
    },
    callAfterShow: function () {
        var t0 = Ext.getCmp(this.cid + "DOLEWKA");
        var t1 = Ext.getCmp(this.cid + "NAPRAWA_BIEZACA");
        var t2 = Ext.getCmp(this.cid + "OBSLUGA_TECHNICZNA");
        var t3 = Ext.getCmp(this.cid + "NAPRAWA_GWARANCYJNA");
        var t4 = Ext.getCmp(this.cid + "NAPRAWA_WYPADKOWA");
        var t5 = Ext.getCmp(this.cid + "OPIS_NIE_DOTYCZY");
        var t6 = Ext.getCmp(this.cid + "POGOTOWIE_TECHNICZNE");
        var bbem = this.datad.mainCtrl.repDef.typyOperacji.length == 0;
        t0.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_DOLEWKA) || bbem);
        t1.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_BIEZACA) || bbem);
        t2.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_OBSLUGA_TECHNICZNA) || bbem);
        t3.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_GWARANCYJNA) || bbem);
        t4.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_WYPADKOWA) || bbem);
        t5.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_OPIS_NIE_DOTYCZY) || bbem);
        t6.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyOperacji, Const.TYP_OPERACJI_ZDARZENIE_POGOTOWIE_TECHNICZNE) || bbem);
        this.callAfterShowCalled = true;
    },
    callAfterHide: function () {
        if (this.callAfterShowCalled) {
            var t0 = Ext.getCmp(this.cid + "DOLEWKA");
            var t1 = Ext.getCmp(this.cid + "NAPRAWA_BIEZACA");
            var t2 = Ext.getCmp(this.cid + "OBSLUGA_TECHNICZNA");
            var t3 = Ext.getCmp(this.cid + "NAPRAWA_GWARANCYJNA");
            var t4 = Ext.getCmp(this.cid + "NAPRAWA_WYPADKOWA");
            var t5 = Ext.getCmp(this.cid + "OPIS_NIE_DOTYCZY");
            var t6 = Ext.getCmp(this.cid + "POGOTOWIE_TECHNICZNE");
            this.datad.mainCtrl.repDef.typyOperacji = [];
            if (t0.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_DOLEWKA);
            if (t1.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_BIEZACA);
            if (t2.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_OBSLUGA_TECHNICZNA);
            if (t3.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_GWARANCYJNA);
            if (t4.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_NAPRAWA_WYPADKOWA);
            if (t5.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_OPIS_NIE_DOTYCZY);
            if (t6.getValue())
                this.datad.mainCtrl.repDef.typyOperacji.push(Const.TYP_OPERACJI_ZDARZENIE_POGOTOWIE_TECHNICZNE);
        }
        return null;
    },
    setData: function (datad) {
        this.datad = datad;
    }
});
